import { decodeMixedArray } from "./decodeMixedArray";
import { decodeNull } from "./decodeNull";
import { decodeNumber } from "./decodeNumber";
import { decodeNumberArray } from "./decodeNumberArray";
import { decodeRecord } from "./decodeRecord";
import { decodeString } from "./decodeString";
import {
  MIXED_ARRAY_MARKER,
  NULL_MARKER,
  NUMBER_ARRAY_MARKER_BY_WIDTH,
  NUMBER_MARKER_BY_WIDTH,
  RECORD_MARKER,
  STRING_MARKER,
} from "./markers";
import { EncodableValue } from "./types";

// Pre-built sets avoid re-allocating Object.values() arrays on every decode call.
const NUMBER_MARKERS = new Set<number>(Object.values(NUMBER_MARKER_BY_WIDTH));
const NUMBER_ARRAY_MARKERS = new Set<number>(
  Object.values(NUMBER_ARRAY_MARKER_BY_WIDTH),
);

export function decodeAny(
  data: Uint8Array,
  offset = 0,
): [EncodableValue, number] {
  const marker = data[offset];
  if (marker === NULL_MARKER) {
    return decodeNull();
  } else if (marker === STRING_MARKER) {
    return decodeString(data, offset);
  } else if (marker === RECORD_MARKER) {
    return decodeRecord(data, offset);
  } else if (NUMBER_MARKERS.has(marker)) {
    return decodeNumber(data, offset);
  } else if (NUMBER_ARRAY_MARKERS.has(marker)) {
    return decodeNumberArray(data, offset);
  } else if (marker === MIXED_ARRAY_MARKER) {
    return decodeMixedArray(data, offset);
  }

  throw new Error(`Unknown value marker: 0x${marker.toString(16)}`);
}
